/** Крихти сторінок модуля (UIUX layout/breadcrumbs): «Робочий простір › Група (› Підгрупа) › Модуль (› Розділ)». */
import { routes } from '@platform/core/lib/routes';
import type { ILocalizedText } from '@platform/core/types';
import type { ICrumb, INavPlacement } from '@platform/navigation';

/**
 * Рівні крихт (чиста функція): робочий простір (→ головна), група верхнього меню модуля (→ «Усі модулі» з категорією групи, `?cat=`), а для
 * модулів підгруп (Експерти, Розвиток) — одна крихта «Група › Підгрупа» (прототип v4 CRUMB_CAT: «Управління › Розвиток» одним посиланням на
 * «Усі модулі» підгрупи), модуль, далі `tail` (Налаштування, «Проєктування · Функції»). Модуль веде туди, куди прототип: типово —
 * повернення до модуля (page:'module' без openModule: той самий стан, розгорнуті «Налаштування» й «Проєктування» лишаються), або на
 * `module.to` (батьківський модуль дочірньої таблиці — нове відкриття, openModule(pmC)). Без місця в навігації рівень групи пропускається.
 * Останній рівень Breadcrumbs показує як поточну сторінку, без посилання.
 */
export function moduleCrumbs(
  ws: { id: string; name: string }, place: INavPlacement | null, module: { key: string; name: string; to?: string },
  label: (text: ILocalizedText) => string, tail: ICrumb[] = [],
): ICrumb[] {
  const all = (category: string) => `${routes.modules()}?cat=${encodeURIComponent(category)}`;
  const group: ICrumb[] = !place ? [] : place.subgroup
    ? [{ label: `${label(place.group.crumb)} › ${label(place.subgroup.label)}`, to: all(place.subgroup.category) }]
    : [{ label: label(place.group.crumb), to: all(place.group.category) }];
  return [{ label: ws.name, to: routes.home() }, ...group, { label: module.name, to: module.to ?? routes.moduleReturn(module.key) }, ...tail];
}
